import React, { useLayoutEffect, useRef } from 'react';
import gsap from 'gsap';
const wrapperStyle = {
    position: 'relative',
    width: '3.8rem',
    height: '1.6rem',
};
const waveStyle = {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
};
const SoundWave = (props) => {
    const renderPlay = () => (React.createElement("svg", { width: "39", height: "16", viewBox: "0 0 39 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36.5914 2.97218V12.3776H35.5914V2.97218H36.5914Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32.3892 13.861V1.98331L31.3892 1.98331V13.861H32.3892Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.3311 1.98332L15.3311 13.861H14.3311L14.3311 1.98332H15.3311Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.2861 4.94996V11.3888H18.2861V4.94996H19.2861Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23.4914 1.98332L23.4914 13.861H22.4914L22.4914 1.98332H23.4914Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27.9403 11.3888V4.45551H26.9403V11.3888H27.9403Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.1289 0.5L11.1289 15.3443H10.1289L10.1289 0.5L11.1289 0.5Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.92719 2.97218L6.92719 12.3776H5.92719L5.92719 2.97218H6.92719Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.72498 9.90545L2.72498 5.93882H1.72498L1.72498 9.90545H2.72498Z", fill: "white" })));
    const renderPause = () => (React.createElement("svg", { width: "38", height: "16", viewBox: "0 0 38 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.72498 10.5L2.72498 5.5L1.72498 5.5L1.72498 10.5H2.72498Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.9277 5.5L6.9277 10.5H5.9277L5.9277 5.5L6.9277 5.5Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.1304 5.5L11.1304 10.5H10.1304L10.1304 5.5L11.1304 5.5Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.3332 5.5L15.3331 10.5H14.3331L14.3332 5.5L15.3332 5.5Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.2887 5.5V10.5H18.2887V5.5L19.2887 5.5Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23.4914 5.5V10.5H22.4914V5.5L23.4914 5.5Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27.9413 10.5V5.5L26.9413 5.5V10.5H27.9413Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32.3913 10.5V5.5L31.3913 5.5V10.5H32.3913Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36.594 5.5V10.5H35.594V5.5L36.594 5.5Z", fill: "white" })));
    const renderIcon = () => (props.isPlaying ? renderPlay() : renderPause());
    const currentRef = useRef(null);
    useLayoutEffect(() => {
        if (currentRef.current) {
            const tl = gsap.timeline({ paused: true });
            tl.fromTo(currentRef.current, {
                clipPath: 'polygon(0 0, 0 0, 0 100%, 0 100%)',
                ease: 'linear',
            }, {
                clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
                ease: 'linear',
            });
            tl.progress(props.progress);
        }
    }, [props.progress]);
    return (React.createElement("div", { className: "soundwave-icon--wrapper", style: wrapperStyle },
        React.createElement("div", { className: "soundwave-icon-current", ref: currentRef, style: waveStyle }, renderIcon()),
        React.createElement("div", { className: "soundwave-icon-total", style: Object.assign(Object.assign({}, waveStyle), { opacity: 0.4 }) }, renderIcon())));
};
export default SoundWave;
